import { LitElement, html } from 'lit';

export class ToastNotifications extends LitElement {
  static properties = {
    toasts: { type: Array }
  };

  constructor() {
    super();
    this.toasts = [];
  }

  createRenderRoot() {
    // Light DOM to inherit Tailwind/global styles
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    // Expose a global reference for easy access
    window.__toastNotifications = this;
    // Listen for notify events dispatched on window or this element
    window.addEventListener('notify', this._handleNotifyEvent);
    this.addEventListener('notify', this._handleNotifyEvent);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (window.__toastNotifications === this) {
      window.__toastNotifications = null;
    }
    window.removeEventListener('notify', this._handleNotifyEvent);
    this.removeEventListener('notify', this._handleNotifyEvent);
  }

  _handleNotifyEvent = (e) => {
    const { message, type = 'info', duration = 5000 } = e.detail || {};
    if (!message) return;
    this.show(message, type, duration);
  };

  show(message, type = 'info', duration = 5000) {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const toast = { id, message, type };
    this.toasts = [...this.toasts, toast];

    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
  }

  dismiss(id) {
    this.toasts = this.toasts.filter(t => t.id !== id);
  }

  _iconFor(type) {
    switch (type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'warning': return '⚠️';
      default: return 'ℹ️';
    }
  }

  render() {
    if (!this.toasts || this.toasts.length === 0) return html``;

    return html`
      <div class="fixed top-4 right-4 z-50 flex flex-col gap-2">
        ${this.toasts.map(t => html`
          <div class="notification ${t.type} bg-white shadow-md border rounded-md px-3 py-2 min-w-[240px] max-w-[360px]">
            <div class="flex items-center">
              <span class="mr-3 text-lg">${this._iconFor(t.type)}</span>
              <div class="flex-1">
                <div class="font-medium text-sm">${t.message}</div>
              </div>
              <button class="ml-3 text-gray-500 hover:text-gray-700" @click=${() => this.dismiss(t.id)} title="Dismiss">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </button>
            </div>
          </div>
        `)}
      </div>
    `;
  }
}

customElements.define('toast-notifications', ToastNotifications);
